import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    maxWidth: '1000px',
    margin: '0 auto',
  },
  innerContainer: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
  },
  containerQuestion: {},
  header: {},
  title: {
    color: '#06040A',
    fontSize: '40px',
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: '600',
    letterSpacing: '0.4px',
    margin: '0px 0px 24px 0px',
    [theme.breakpoints.up('sm')]: {
      margin: '0px 0px 48px 0px',
      fontSize: '40px',
    },
  },
  dialog: {
    '& .MuiDialog-paper': {
      maxWidth: '800px',
      width: '90%',
      maxHeight: '90vh',
      margin: '20px',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  content: {
    padding: theme.spacing(3),
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    color: theme.palette.primary.main,
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subsection: {
    marginBottom: theme.spacing(3),
  },
  subsectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  paragraph: {
    marginBottom: theme.spacing(2),
    fontSize: '1rem',
    lineHeight: 1.6,
    fontFamily: 'Open Sans, sans-serif',
  },
  boldText: {
    fontWeight: 600,
    fontFamily: 'Open Sans, sans-serif',
  },
  list: {
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  orderedList: {
    listStyleType: 'decimal',
  },
  unorderedList: {
    listStyleType: 'disc',
  },
  listItem: {
    marginBottom: theme.spacing(1),
    // '&::marker': {
    //   color: theme.palette.primary.main,
    // },
  },
}));
